import {combineReducers} from 'redux';
import {apiSlice} from '../api/apiSlice.js';
import activeQuad from './active-quad.js';
import cursor from './cursor.js';
import filter from './filter.js';
import footprint from './footprint.js';
import geocoder from './geocoder.js';
import geometry from './geometry.js';
import items from './items.js';
import map from './map.js';
import mosaics from './mosaics.js';
import provenanceData from './provenance-data.js';
import quads from './quads.js';
import selectedQuad from './selected-quad.js';
import selectedScene from './selected-scene.js';
import ui from './ui.js';

const combinedReducers = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  activeQuad,
  selectedQuad,
  cursor,
  filter,
  footprint,
  geocoder,
  geometry,
  items,
  map,
  mosaics,
  provenanceData,
  quads,
  selectedScene,
  ui,
});

export default (state, action) => {
  return combinedReducers(state, action);
};
